import React from 'react';
import './index.css';

const FestiveProcess = ({ config }) => {
  const processData = config.process;
  const items = Array.isArray(processData?.items) ? processData.items : [];

  return (
    <section id="process" className="fs-process">
      <div className="fs-process__deco fs-process__deco--1" />
      <div className="fs-process__deco fs-process__deco--2" />
      <div className="container">
        <div className="fs-process__header text-center">
          <span className="fs-process__kicker">{processData?.sub_heading || ''}</span>
          <h2 className="fs-process__title">{processData?.heading || 'How It Works'}</h2>
        </div>
        <div className="fs-process__timeline">
          {items.map((step, idx) => (
            <div key={idx} className="fs-process__step">
              <div className="fs-process__step-line">
                <div className="fs-process__step-number">{idx + 1}</div>
              </div>
              <div className="fs-process__step-icon">{step.icon}</div>
              <h4 className="fs-process__step-title">{step.title}</h4>
              <p className="fs-process__step-desc">{step.desc || step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

const RoyalProcess = ({ config }) => {
  const processData = config.process;
  const items = Array.isArray(processData?.items) ? processData.items : [];

  return (
    <section id="process" className="rc-process">
      <div className="container">
        <div className="rc-process__header text-center">
          <span className="rc-process__kicker">{processData?.sub_heading || ''}</span>
          <h2 className="rc-process__title">{processData?.heading || 'How It Works'}</h2>
          <div className="rc-process__line" />
        </div>
        <div className="rc-process__grid">
          {items.map((step, idx) => (
            <div key={idx} className="rc-process__card">
              <div className="rc-process__card-num">{String(idx + 1).padStart(2, '0')}</div>
              <div className="rc-process__card-icon">{step.icon}</div>
              <h4 className="rc-process__card-title">{step.title}</h4>
              <p className="rc-process__card-desc">{step.desc || step.description}</p>
              <div className="rc-process__card-glow" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

const TraditionalProcess = ({ config }) => {
  const processData = config.process;
  const items = Array.isArray(processData?.items) ? processData.items : [];

  return (
    <section id="process" className="ts-process">
      <div className="container">
        <div className="ts-process__header text-center">
          <div className="ts-process__badge">{processData?.sub_heading || ''}</div>
          <h2 className="ts-process__title">{processData?.heading || 'How It Works'}</h2>
        </div>
        <div className="ts-process__list">
          {items.map((step, idx) => (
            <div key={idx} className="ts-process__item">
              <div className="ts-process__item-icon">{step.icon}</div>
              <div className="ts-process__item-content">
                <h4 className="ts-process__item-title">{step.title}</h4>
                <p className="ts-process__item-desc">{step.desc || step.description}</p>
              </div>
              <div className="ts-process__item-num">{idx + 1}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

const LegacyAshaProcess = ({ config }) => {
  const processData = config.process;
  const items = Array.isArray(processData?.items) ? processData.items : [];

  return (
    <section id="process" className="asha-process">
      <div className="container">
        <div className="asha-process__header text-center">
          <span className="asha-process__kicker">{processData?.sub_heading || ''}</span>
          <h2 className="asha-process__title">{processData?.heading || 'How It Works'}</h2>
          <div className="asha-process__divider" />
        </div>
        <div className="asha-process__grid">
          {items.map((step, idx) => (
            <div key={idx} className="asha-process__step">
              <div className="asha-process__num">{idx + 1}</div>
              <div className="asha-process__icon-box">
                <span className="asha-process__icon">{step.icon}</span>
              </div>
              <h4 className="asha-process__step-title">{step.title}</h4>
              <p className="asha-process__step-desc">{step.desc || step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
const CafeProcess = ({ config }) => {
  const processData = config.process;
  const items = Array.isArray(processData?.items) ? processData.items : [];

  return (
    <section id="process" className="cafe-process">
      <div className="container">
        <div className="cafe-process__header text-center">
          <span className="cafe-process__kicker">{processData?.sub_heading || ''}</span>
          <h2 className="cafe-process__title">{processData?.heading || 'How It Works'}</h2>
          <div className="cafe-process__ornament">
            <span className="cafe-ornament-line" />
            <span className="cafe-ornament-icon">☕</span>
            <span className="cafe-ornament-line" />
          </div>
        </div>
        <div className="cafe-process__grid">
          {items.map((step, idx) => (
            <div key={idx} className="cafe-process__card">
              <div className="cafe-process__card-num">{String(idx + 1).padStart(2, '0')}</div>
              <div className="cafe-process__card-icon">{step.icon}</div>
              <h4 className="cafe-process__card-title">{step.title}</h4>
              <p className="cafe-process__card-desc">{step.desc || step.description}</p>
              <div className="cafe-process__card-glow" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

const ModernProcess = ({ config }) => {
  const processData = config.process;
  const items = Array.isArray(processData?.items) ? processData.items : [];

  return (
    <section id="process" className="modern-process">
      <div className="container">
        <div className="modern-process__header">
          <h2 className="modern-process__title">{processData?.heading}</h2>
          <span className="modern-process__kicker">{processData?.sub_heading}</span>
          <div className="modern-testimonials__title-line" />

        </div>
        <div className="modern-process__grid">
          {items.map((step, idx) => (
            <div key={idx} className="modern-process__step">
              <div className="modern-process__step-number">{String(idx + 1).padStart(2, '0')}</div>
              <div className="modern-process__step-icon-wrapper">
                <div className="modern-process__step-icon">{step.icon}</div>
              </div>
              <div className="modern-process__step-content">
                <h4 className="modern-process__step-title">{step.title}</h4>
                <p className="modern-process__step-desc">{step.desc || step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

const ProcessSection = (props) => {
  const type = (props.config.templateType || 'template1').toLowerCase().replace(/-/g, '_');

  switch (type) {
    case 'template4':
    case 'traditional_sweets':
      return <TraditionalProcess {...props} />;
    case 'template5':
      return <LegacyAshaProcess {...props} />;
    case 'template9':
    case 'template10':
    case 'festive_sweets':
      return <FestiveProcess {...props} />;
    case 'template11':
    case 'royal_confections':
      return <RoyalProcess {...props} />;
    case 'template14':
    case 'cafe_premium':
      return <CafeProcess {...props} />;
    case 'template15':
    case 'dry_fruits':
    default:
      return <ModernProcess {...props} />;
  }
};

export default ProcessSection;
